import { priceFromCost, clampParam } from "@acc/shared"
import { calcYaLogisticByWeight } from "./calcYaLogisticByWeight"

/**
 * Калькулятор цены Яндекс.Маркет (фронт).
 *
 * Делегирует математику движку priceFromCost из @acc/shared.
 * Особенность: LOGISTIC — доля от цены (процент за логистику Яндекса), входит в
 * знаменатель вместе с KOEF и EKV. MILA — абсолютная логистика по весу
 * (calcYaLogisticByWeight из @acc/shared), входит как добавка к KASSA.
 *
 * Конфиг комиссий: nalogInKassa=true, denominatorFees=[KOEF, EKV, LOGISTIC],
 * additives=[MILA (= calcYaLogisticByWeight(weight)), PRIEMKA].
 */
export const calcPriceForYandex = (props: {
  sale?: number
  price?: number
  margin?: number
  profit?: number
  logistic?: number
  ff?: number
  coef?: number
  tax?: number
  priemka?: number
  ekv?: number
  mila?: number
  weight?: number
}): { price: number; old_price: number } => {
  const {
    sale = 0,
    price = 0,
    margin = 0,
    profit = 0,
    logistic = 0,
    ff = 0,
    coef = 0,
    tax = 0,
    priemka = 0,
    ekv = 0,
    weight = 0,
  } = props
  const MILA = calcYaLogisticByWeight(weight)
  const currentPrice = priceFromCost(
    {
      price,
      margin: clampParam(margin, 0),
      minProfit: clampParam(profit, 0),
      ff: clampParam(ff, 0),
      nalog: clampParam(tax, 0),
      sale: Math.max(sale, 0) / 100,
      withSale: false,
    },
    {
      nalogInKassa: true,
      denominatorFees: [
        clampParam(coef, 0),
        clampParam(ekv, 0),
        clampParam(logistic, 0),
      ],
      additives: [MILA, clampParam(priemka, 0)],
    },
  )
  const SALE = Math.max(sale, 0) / 100
  return {
    price: currentPrice,
    old_price: Math.ceil(currentPrice / (1 - SALE)),
  }
}
